module.exports = __webpack_public_path__ + "static/media/workflow_i.5a155ce9.svg";